import Keyboard from './Keyboard';
import KeyboardBindings from './KeyboardBindings';

export default {
  __init__: [ 'keyboard', 'keyboardBindings' ],
  keyboard: [ 'type', Keyboard ],
  keyboardBindings: [ 'type', KeyboardBindings ]
};
